import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { Brand } from '@/components/Brand';

export function Footer() {
  return (
    <footer className="border-t border-border/70 bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <Brand />
          </div>
          <p className="mt-3 text-sm text-muted-foreground max-w-sm leading-relaxed">
            Curadoria de viagens e turismo com atendimento personalizado. Realizamos sonhos com
            segurança, organização e experiências inesquecíveis.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3">Navegação</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-foreground">Início</Link></li>
            <li><Link to="/galeria" className="hover:text-foreground">Viagens</Link></li>
            <li><Link to="/quem-somos" className="hover:text-foreground">Quem Somos</Link></li>
            <li><Link to="/contato" className="hover:text-foreground">Contato</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3">Contato</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> (11) 99238-7001</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> sandra@sandratur.com.br</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> São Paulo - SP</li>
            <li className="flex items-center gap-2"><Instagram className="h-4 w-4" /> @sandratur</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Sandra Tur — Viagens e Turismo. Todos os direitos reservados.</span>
          <span>Seus dados são tratados conforme a LGPD.</span>
        </div>
      </div>
    </footer>
  );
}
